<template>
    <nav
        class="navbar has-shadow is-fixed-top app-navbar"
        :class="isMobile?'small':'large'"
        role="navigation"
        aria-label="main navigation"
    >
        <div class="navbar-brand ml-3">
            <router-link :to="'/'" class="navbar-item is-marginless">
                <img
                    src="@/assets/images/logo_eduloc360.png"
                    alt="eduloc360"
                    width="160"
                    height="50"
                />
            </router-link>
            <a
                role="button"
                class="navbar-burger burger"
                aria-label="menu"
                aria-expanded="false"
                data-target="navbar"
                @click="menuActive = !menuActive"
            >
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
            </a>
        </div>

        <div
            id="navbar"
            :class="{ 'is-active': menuActive }"
            class="navbar-menu"
            @click="menuActive = false"
        >
            <div class="navbar-start" :class="{'ml-6': !isMobile}">
                <router-link
                    v-if="isLoggedIn && !$store.getters.isAnonymous && canCreateProject"
                    class="navbar-item"
                    
                    to="/creation"
                    >{{ $t('Navbar.create') }}</router-link
                >
                <router-link
                    v-if="isLoggedIn && !$store.getters.isAnonymous"
                    :to="{
                        path: '/dashboard',
                        query: {
                            filter: canCreateProject?'mine':'access',
                        },
                    }"
                    class="navbar-item"
                    
                    >{{ $t('Navbar.myspace') }}</router-link
                >
                <!--<router-link
                    class="navbar-item"
                    to="/explore"
                    
                    >{{ $t('featured_projects') }}</router-link
                >-->
                <router-link
                    v-if="isLoggedIn && !$store.getters.isAnonymous && isCoordinator"
                    :to="{
                        path: '/management',
                    }"
                    class="navbar-item"
                    
                    
                    ><!--{{ $t('my_entity') }}-->{{ schoolName }}</router-link
                >

                <!--<a
                    class="navbar-item"
                    :href="playUrl"
                    target="_blank"
                    >{{ $t('play_session') }}</a
                >-->
            </div>

            <div class="navbar-end">
                <!--<mq-layout mq="tablet+">
                    <app-navbar-user-menu />
                </mq-layout>-->
                <hr v-if="isMobile" class="navbar-divider"/>
                <!--<span class="navbar-item is-flex" @click="openProfile" v-if="$store.getters.isLoggedIn && !$store.getters.isAnonymous">
                    <router-link
                        :to="{
                            name: 'dashboard-user'
                        }"
                        exact
                        class=""
                    >
                        <img
                            v-if="showBadge"
                            src="@/assets/images/alerta_campana.svg"
                            alt="alerta"
                            class="nou_missatge"
                        />
                        {{ $t('hi') }} {{$store.getters.personalData.name}} <span v-if="showEntityName">({{ schoolName }})</span>
                    </router-link>
                    
                </span>-->
                <span class="navbar-item is-flex" v-if="$store.getters.isLoggedIn && !$store.getters.isAnonymous && showBadge">
                    <router-link
                        :to="{
                            name: 'dashboard-user'
                        }"
                        exact
                        class=""
                    >
                        <img
                            src="@/assets/images/alerta_campana.svg"
                            alt="alerta"
                            class="nou_missatge"
                        />
                    </router-link>
                </span>
                <!--<a v-if="$store.getters.isLoggedIn && !$store.getters.isAnonymous"
                    class="navbar-item is-flex"
                    @click="logout"
                    >
                    
                    <span class="icon ml-2">
                        <i class="mdi mdi-28px mdi-logout pr-4"></i>
                    </span>
                    
                </a>-->
                <div class="navbar-item is-flex has-dropdown is-hoverable" v-if="$store.getters.isLoggedIn && !$store.getters.isAnonymous">
                    <a class="navbar-link">
                        {{$store.getters.personalData.name}} &nbsp;<span v-if="showEntityName">({{ schoolName }})</span>
                    </a>

                    <div class="navbar-dropdown user-menu">
                        <a class="navbar-item disabled" disabled v-if="showEntityMenu">{{ $t('change_user_entity') }}</a>
                        
                        <div v-for="entity in userEntites" :key="entity._id">
                            <a v-if="entity.entity._id!=$store.getters.school._id" @click="changeActiveEntity(entity)" :disabled="entity.entity._id==$store.getters.school._id" class="navbar-item" :class="{ 'disabled':entity.entity._id==$store.getters.school._id}">
                                {{ entity.entity.name }}
                            </a>
                        </div>
                        
                        <a class="navbar-item disabled" disabled>{{ $t('other') }}</a>
                        
                        <router-link
                            :to="{
                                name: 'dashboard-user'
                            }"
                            exact
                            class=" navbar-item"
                        >
                            
                            {{ $t('user_profile') }} 
                        </router-link>
                        
                        <a class="navbar-item" @click="logout">
                            {{ $t('close_session') }}
                    <!--<span class="icon ml-2">
                        <i class="mdi mdi-28px mdi-logout pr-4"></i>
                    </span>-->
                    
                        </a>
                        
                    </div>
                </div>
 

                <a v-else class="navbar-item is-flex"
                    @click="logout">Login</a>
                <hr v-if="isMobile" class="navbar-divider"/>
                <div class="navbar-item has-dropdown is-hoverable has-border-left" v-if="!isMobile">
                    <a class="navbar-link is-arrowless mr-4">
                    <span class="icon mr-1"><i class="mdi mdi-18px mdi-web"></i></span>
                    {{ $i18n.locale | localePrint }}
                    </a>

                    <div class="navbar-dropdown">
                        <a
                            v-for="locale in locales"
                            :key="locale"
                            @click="switchLocale(locale)"
                            class="navbar-item"
                        >
                            {{ locale | localePrint }}
                        </a>
                    
                    </div>
                </div>
                
                <div class="navbar-item columns" v-else>
                    <a
                            v-for="locale in locales"
                            :key="locale"
                            @click="switchLocale(locale)"
                            class="lang-menu-item column is-6-mobile"
                            :class="{'active':isLangActive(locale)}"
                        >
                            {{ locale | localePrint }}
                        </a>
                </div>
                
            </div>
        </div>
    </nav>
</template>

<script>
import AppNavbarUserMenu from '@/components/AppNavbarUserMenu';
import moment from 'moment';
import { setActiveEntity } from '@/services/API';
export default {
    components: {
        AppNavbarUserMenu,
    },
    props: {
        active: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            menuActive: false,
            locales: process.env.VUE_APP_I18N_SUPPORTED_LOCALE.split(','),
            //activePlan: this.$store.getters.activePlan,
        };
    },
    filters: {
        localePrint(locale) {
            return locale.slice(0, 2).toUpperCase();
        },
    },
    computed: {
        activePlan() {
            return this.$store.getters.activePlan;
        },
        isLoggedIn() {
            return this.$store.getters.isLoggedIn;
        },
        location() {
            return location;
        },
        playUrl() {
            return process.env.VUE_APP_PLAY_URL + '/?lang=' + this.$i18n.locale;
        },
        isMobile(){
            return this.$mq=="mobile"
        },
        canCreateProject() {
            if (this.isAdmin) {
                return true;
            }
            let canCreate = false;
            // console.log("can create project?",this.$store.getters.canCreateProject)
            if (this.isLoggedIn && !this.$store.getters.isAnonymous && this.$store.getters.canCreateProject) {
                // console.log(this.$store.getters.user.entities)
                if (this.$store.getters.user.entities) {
                    // console.log("checking entities permissions")
                    this.$store.getters.user.entities.forEach(element => {
                        
                        if ((element.entity._id == this.$store.getters.user.school._id) && (element.permission != 'GUEST')) {
                            // console.log("no creation")
                            canCreate = true;
                        } /*else {
                            // console.log("can create")
                            canCreate=true
                        }*/
                    });
                } 
                
            }
            // console.log("no creation")
            return canCreate;
        },
        isAdmin() {
            return this.$store.getters.isAdmin;
        },
        isCoordinator() {
            return this.$store.getters.hasSchool && this.$store.getters.canManageSchool;
        },
        schoolName() {
            if (this.$store.getters.school) {
                return this.$store.getters.school.name
            }
        },
        hasSchool() {
            return this.$store.getters.hasSchool;
        },
        showBadge() {
            // console.log("active plan",this.activePlan)
            if (this.hasSchool && this.activePlan) {
                if (this.activePlan.configuration.general.endDate) {
                    const data2 = moment(this.activePlan.configuration.general.endDate, "DD-MM-YYYY");
                    const data1 = moment();
                    const daysDiff = data2.diff(data1, 'days');
                    if (data1.isBefore(data2) && daysDiff <= 5) {
                        return true
                    }
                }
            }
            return false;
        },
        showEntityName() {
            return this.hasSchool && this.schoolName!="EDULOC360" && this.schoolName!="Eduloc360 APP"
        },
        showEntityMenu() {
            return this.$store.getters.user.entities && this.$store.getters.user.entities.length > 1;
        },
        userEntites() {
            //console.log(this.$store.getters.user.entities)
            return this.$store.getters.user.entities;
        },
        isGuest() {
            let isGuest=false;
            if (this.isAdmin) {
                // console.log("isGuest? is admin",isGuest)
                return false;
            }
            if (this.$store.getters.user.entities) {
                // console.log("checking entities permissions")
                this.$store.getters.user.entities.forEach(element => {
                    // console.log(element.entity._id,this.$store.getters.user.school._id)
                    if ((element.entity._id == this.$store.getters.user.school._id) && (element.permission == 'GUEST')) {
                        // console.log("is guest")
                        isGuest = true;
                    } /*else {
                        console.log("not guest")
                        isGuest = false;
                    }*/
                });
            } else {
                // console.log("not guest 2")
                isGuest = false;
            }
            // console.log("isGuest?",isGuest)
            return isGuest;
            //return this.isAdmin
        }

        
    },
    methods: {
        isLangActive(locale){
            return this.$i18n.locale == locale;
        },
        logout() {
            if (this.$gapi.isAuthenticated()) {
                this.$gapi.logout();
            }
            this.$store.dispatch('logout');
            this.$router.push('/');
        },
        switchLocale(locale) {
            if (this.$i18n.locale !== locale) {
                this.$i18n.locale = locale;
            }
        },
        openProfile() {
            //console.log("go to profile")

        },
        async changeActiveEntity(entity) {
            if (entity.entity._id == this.$store.getters.school._id) {
                return;
            }
            //console.log("changing active entity");
            let error = false;
            await setActiveEntity({ 'id': entity._id })
            .catch((e) => {
                console.log("error", e)
                error = true;
                return;
            })
            .finally((userData) => {
                if (!error) {
                    // console.log("entity updated",userData)
                    this.$store.dispatch('fetchProfile').then(() => {
                        if (this.$route.path == '/dashboard') {
                            location.reload();
                        } else if (this.isGuest) {
                            this.$router.push({ path: '/dashboard', query: { filter: 'access' } })
                        } else {
                            this.$router.push({ path: '/dashboard', query: { filter: 'mine' } })
                        }
                       
                    });
                    
                    

                    //this.$router.push({path: '/'})
                }
            });
        }
        
    },
};
</script>

<style scoped>
@import '../assets/css/navbar.css';
.lb-app-navbar {
    z-index: 31 !important;
}
.notification-badge{
    background-color: var(--eduloc-yellow);
    top: 15px;
    height: 10px;
    padding: 0;
    min-width: 10px;
    border-radius: 10px;
    box-shadow: none;
    right: 6px;
}
.nou_missatge{
    height: 1.5rem;
    display: inline-block;
    margin-right: 0.75rem;
    margin-bottom: 0.2rem;
}
a.navbar-item.is-active{
    color: var(--eduloc-yellow);
}
.navbar-link:not(.is-arrowless)::after{
    border-color: #FFFFFF; 
}
a.navbar-item.disabled{
    color: var(--eduloc-grey) !important;
    font-style: italic;
}
a.navbar-item.disabled:hover{
    color: var(--eduloc-grey) !important;
    font-style: italic;
    cursor: default;
    background-color: transparent;
}

.user-menu hr{
    margin-bottom: 0;
    margin-top: 0;
}
.user-menu .navbar-item{
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    padding-left: 2rem;
}
.user-menu .navbar-item.disabled{
    padding-top: 0.5rem;
    padding-bottom: 0;
    padding-left: 1rem;
}
</style>
